import { createSlice } from "@reduxjs/toolkit";

export const documentosSlice = createSlice({
    name: 'articulos',
    initialState: {
        allDocumentos: [],
        documentoId:[],
        documentoNew: {},
        deleteDocumento: {},
        putArmadoEntregado: {},
        putDocumento: {}
    },
    reducers: {
      allDocumentos: (state, {payload}) => {
        state.allDocumentos = payload
      },
      documentoId: (state, {payload}) => {
        state.documentoId = payload
      },
      documentoNew: (state, {payload}) => {
        state.documentoNew = payload
      },
      deleteDocumento: (state, {payload}) => {
        state.deleteDocumento = payload
      },
      putArmadoEntregado: (state, {payload}) => {
        state.putArmadoEntregado = payload
      },
      putDocumento: (state, {payload}) => {
        state.putDocumento = payload
      }
    }
})

export const { allDocumentos, documentoId, documentoNew, deleteDocumento, putArmadoEntregado, putDocumento } = documentosSlice.actions;

export default documentosSlice.reducer;